import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IConta } from '@model/Conta';
import { IContaFilter } from '@services/ContaService';
import React from 'react';
import { ContaDetalheModal } from './ContaDetalheModal';

export type ContaTableProps = {
    isLoading: boolean
    data: IData<IConta, IContaFilter>
    tableContainerProps?: TableContainerProps
}

export function ContaTable ({ isLoading, data, tableContainerProps }: ContaTableProps) {
    const formatter = useFormatter();
    const detalheModal = useModalWindow();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="contaId">ID</TableSortCell>
                        <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="operadoraNome">Operadora</TableSortCell>
                        <TableSortCell fieldName="periodoDe">Período De</TableSortCell>
                        <TableSortCell fieldName="periodoAte">Período Até</TableSortCell>
                        <TableSortCell fieldName="competencia">Competência</TableSortCell>
                        <TableSortCell fieldName="numeroFatura">Nº Fatura</TableSortCell>
                        <TableSortCell fieldName="processamento">Processada em</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((conta, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(conta, detalheModal.open)}>{conta.contaId}</Anchor></TableKeyCell>
                                    <TableCell>{conta.empresaNome}</TableCell>
                                    <TableCell>{conta.operadoraNome}</TableCell>
                                    <TableCell>{formatter.toDate(conta.periodoDe)}</TableCell>
                                    <TableCell>{formatter.toDate(conta.periodoAte)}</TableCell>
                                    <TableCell>{formatter.toCompetencia(conta.competencia)}</TableCell>
                                    <TableCell>{conta.numeroFatura}</TableCell>
                                    <TableCell>{formatter.toDate(conta.processamento)}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                    <Pagination pagination={data.pagination} />
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <ContaDetalheModal 
                            contaId={data.focusedRow.contaId}
                            modal={detalheModal}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}